export default "__VITE_ASSET__stQuniuH__"